


























































import {Component, Vue} from 'vue-property-decorator';
import api from '@/infrastructure/api/api';

import RegisterTransferMedical from '@/views/transfermedical/RegisterTransferMedical.vue';
import UpdateTransferMedical from '@/views/transfermedical/UpdateTransferMedical.vue';

import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import {progress} from '@/script/progress';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import {譲渡譲受医療機関型, 削除フラグ型, 譲渡譲受医療機関削除依頼型} from '@/type/transfermedical/transferMedical';
import {viewEditingStateModule} from '@/store/state/viewEditingState';

@Component({
  components: {
    RegisterTransferMedical,
    UpdateTransferMedical,
    ButtonPanel,
    IconButton,
    ConfirmDialog,
    NormalButton,
    AlertDialog,
  },
})
export default class ListTransferMedicals extends Vue {

  private 医療機関一覧: 譲渡譲受医療機関型[] = [];
  private 選択医療機関: 譲渡譲受医療機関型 | null = null;

  private alertMessage: string | null = null;

  private registerModal: boolean = false;
  private updateModal: boolean = false;

  private created() {
    this.show();
    viewEditingStateModule.初期化する();
  }

  private async show(): Promise<void> {
    await api.削除を含む譲渡譲受医療機関一覧を取得する()
      .then((response: 譲渡譲受医療機関型[]) => {
        this.医療機関一覧 = response;
        if (this.医療機関一覧.length === 0) {
          this.alertMessage = '譲渡譲受医療機関は存在しません';
          this.$modal.show('アラート');
        }
      })
      .catch((error: any) => {
        this.alertMessage = error.data.message;
        this.$modal.show('アラート');
      });
  }

  private select(医療機関: 譲渡譲受医療機関型) {
    if (this.isModalOpen()) {
      return;
    }
    this.選択医療機関 = 医療機関;
  }

  private reload() {
    this.show();
    this.選択医療機関 = null;
  }

  private openRegisterForm() {
    this.registerModal = true;
  }

  private closeRegisterForm() {
    this.reload();
    this.registerModal = false;
    viewEditingStateModule.画面の編集を終了する();
  }

  private openUpdateForm() {
    this.updateModal = true;
    viewEditingStateModule.画面の編集を開始する();
  }

  private isModalOpen() {
    return this.registerModal || this.updateModal;
  }

  private async requestUpdateForm() {
    if (this.選択医療機関 !== null) {
      this.openUpdateForm();
    }
  }

  private closeUpdateForm() {
    this.reload();
    this.updateModal = false;
    viewEditingStateModule.画面の編集を終了する();
  }

  private openDeleteDialog(): void {
    this.$modal.show('deleteConfirmDialog');
  }

  private closeDeleteDialog(): void {
    this.$modal.hide('deleteConfirmDialog');
  }

  private deleteHandler() {
    progress(this.delete);
  }

  private async delete(): Promise<void> {
    if (this.選択医療機関 !== null) {
      const 削除依頼: 譲渡譲受医療機関削除依頼型 = {
        医療機関コード: this.選択医療機関.譲渡譲受医療機関コード,
        更新バージョン: this.選択医療機関.更新バージョン,
      };
      await api.譲渡譲受医療機関を削除する(削除依頼)
        .then(
          () => {
            this.closeDeleteDialog();
            this.reload();
          },
          (error: any) => {
            this.alertMessage = error.data.errors[0];
            this.$modal.show('アラート');
            this.closeDeleteDialog();
          },
        );
    }
  }

  get isDisabled() {
    return this.選択医療機関 === null || this.選択医療機関.削除フラグ === 削除フラグ型.削除;
  }

  private 削除済みである(医療機関: 譲渡譲受医療機関型): boolean {
    return 医療機関.削除フラグ === 削除フラグ型.削除;
  }
}
